import { sanitizeContent } from "./ContentSanitizationUtilities";
let plannerPolicy;
/**
 * Get or create the Planner trusted types policy
 */ const getPlannerPolicy = ()=>{
    if (!plannerPolicy) {
        const ttWindow = window;
        if (!ttWindow?.trustedTypes) {
            return undefined;
        }
        plannerPolicy = ttWindow.trustedTypes.createPolicy("uno-policy", {
            createHTML: (html, skipSanitization)=>{
                return skipSanitization ? html : sanitizeContent(html);
            },
            // TODO: Add URL validation/sanitization logic to ensure only trusted script sources are allowed
            createScriptURL: (url)=>url
        });
    }
    return plannerPolicy;
};
/**
 * Create trusted html
 */ export const createTrustedHtml = (html, skipSanitization = false)=>{
    const policy = getPlannerPolicy();
    if (!policy) {
        return html;
    }
    // TODO: Remove type assertion and update return type to "string | TrustedHTML" when TypeScript DOM lib includes Trusted Types support.
    // See: https://github.com/microsoft/TypeScript/issues/30024
    return policy.createHTML(html, skipSanitization);
};
/**
 * Create trusted script URL
 */ export const createTrustedScriptUrl = (url)=>{
    const policy = getPlannerPolicy();
    if (!policy) {
        return url;
    }
    // TODO: Remove type assertion and update return type to "string | TrustedScriptURL" when TypeScript DOM lib includes Trusted Types support.
    // See: https://github.com/microsoft/TypeScript/issues/30024
    return policy.createScriptURL(url);
};
/**
 * Test helper - reset cached Trusted Types policies.
 * Only intended for use in unit tests to clear module-level cache between tests.
 */ export const __resetPolicyCache = ()=>{
    plannerPolicy = undefined;
};
